































import { Component, Vue } from 'vue-property-decorator';
import { AuthApi } from '../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		Toast,
	},
})
export default class EmailChange extends Vue {
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public error = null;
	public countDown = 5;

	public countDownTimer() {
		if (this.countDown > 0) {
			setTimeout(() => {
				this.countDown -= 1;
				this.countDownTimer();
			}, 1000);
		}
		if (this.countDown === 0) {
			this.$router.push({ name: 'auth.login' });
		}
	}

	public created() {
		this.load();
	}

	public async load() {
		const userId: string = this.$route.params.token;
		const signature: string = this.$route.query.signature;
		const expires: string = this.$route.query.expires;

		// console.log(userId);
		// console.log(signature);
		// console.log(expires);

		let response;

		try {
			response = await new AuthApi().changeEmail(userId, expires, signature);
		} catch (e) {
			console.log(e.response.data);
			this.error = e.response.data.message;
			this.submitStatus = 'ERROR';
			new Toast().makeToast(
				'There was a problem confirming your new email address',
				'Error Occurred',
				'danger',
			);
			this.countDownTimer();
			return;
		}

		new Toast().makeToast('Email Changed', 'Successfully Set', 'success');

		this.submitStatus = 'OK';

		this.countDownTimer();
	}
}
